// Author Shi Wen Long
// Date 2022-04-27 17:26:45

class SithMesStool26StockTransfer {
constructor({
        id = null,
        material = '',
        materialDesc = '',
        oldProjectCode = '',
        oldSo = '',
        oldWbs = '',
        newProjectCode = '',
        so = '',
        wbs = '',
        transferQuantity = '',
        applicant = '',
        applyTime = '',
        isTransfer = '',
        singlePrice = '',
        totalPrice = '',
        remark = '',
        workOrderCode = '',
        status = ''}
= {}) {
    this.id = id;
    this.material = material;
    this.materialDesc = materialDesc;
    this.oldProjectCode = oldProjectCode;
    this.oldSo = oldSo;
    this.oldWbs = oldWbs;
    this.newProjectCode = newProjectCode;
    this.so = so;
    this.wbs = wbs;
    this.transferQuantity = transferQuantity;
    this.applicant = applicant;
    this.applyTime = applyTime;
    this.isTransfer = isTransfer;
    this.singlePrice = singlePrice;
    this.totalPrice = totalPrice;
    this.remark = remark;
    this.workOrderCode = workOrderCode;
    this.status = status;
}
}

function newEntity() {
return new SithMesStool26StockTransfer();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.sith.stool.sithMesStool26StockTransfer.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'material',
        label: 'label.sith.stool.sithMesStool26StockTransfer.grid.material',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'materialDesc',
        label: 'label.sith.stool.sithMesStool26StockTransfer.grid.materialDesc',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'oldProjectCode',
        label: 'label.sith.stool.sithMesStool26StockTransfer.grid.oldProjectCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'oldSo',
        label: 'label.sith.stool.sithMesStool26StockTransfer.grid.oldSo',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'oldWbs',
        label: 'label.sith.stool.sithMesStool26StockTransfer.grid.oldWbs',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'newProjectCode',
        label: 'label.sith.stool.sithMesStool26StockTransfer.grid.newProjectCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'so',
        label: 'label.sith.stool.sithMesStool26StockTransfer.grid.so',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'wbs',
        label: 'label.sith.stool.sithMesStool26StockTransfer.grid.wbs',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'transferQuantity',
        label: 'label.sith.stool.sithMesStool26StockTransfer.grid.transferQuantity',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'applicant',
        label: 'label.sith.stool.sithMesStool26StockTransfer.grid.applicant',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'applyTime',
        label: 'label.sith.stool.sithMesStool26StockTransfer.grid.applyTime',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'isTransfer',
        label: 'label.sith.stool.sithMesStool26StockTransfer.grid.isTransfer',
        sortable: true,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'singlePrice',
        label: 'label.sith.stool.sithMesStool26StockTransfer.grid.singlePrice',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'totalPrice',
        label: 'label.sith.stool.sithMesStool26StockTransfer.grid.totalPrice',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.stool.sithMesStool26StockTransfer.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'workOrderCode',
        label: 'label.sith.stool.sithMesStool26StockTransfer.grid.workOrderCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'status',
        label: 'label.sith.stool.sithMesStool26StockTransfer.grid.status',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'statusName',
        label: 'label.sith.stool.sithMesStool26StockTransfer.grid.statusName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    materialFilter : '',
    materialDescFilter : '',
    oldProjectCodeFilter : '',
    oldSoFilter : '',
    oldWbsFilter : '',
    newProjectCodeFilter : '',
    soFilter : '',
    wbsFilter : '',
    transferQuantityFilter : '',
    applicantFilter : '',
    applyTimeRteFilter : '',
    applyTimeLteFilter : '',
    isTransferFilter : '',
    singlePriceFilter : '',
    totalPriceFilter : '',
    workOrderCodeFilter : '',
    statusFilter : '',
    workflowQueryTypeFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'materialFilter',
        label: 'label.sith.stool.sithMesStool26StockTransfer.filter.material',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'materialDescFilter',
        label: 'label.sith.stool.sithMesStool26StockTransfer.filter.materialDesc',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'oldProjectCodeFilter',
        label: 'label.sith.stool.sithMesStool26StockTransfer.filter.oldProjectCode',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'oldSoFilter',
        label: 'label.sith.stool.sithMesStool26StockTransfer.filter.oldSo',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'oldWbsFilter',
        label: 'label.sith.stool.sithMesStool26StockTransfer.filter.oldWbs',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'newProjectCodeFilter',
        label: 'label.sith.stool.sithMesStool26StockTransfer.filter.newProjectCode',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'soFilter',
        label: 'label.sith.stool.sithMesStool26StockTransfer.filter.so',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'wbsFilter',
        label: 'label.sith.stool.sithMesStool26StockTransfer.filter.wbs',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'transferQuantityFilter',
        label: 'label.sith.stool.sithMesStool26StockTransfer.filter.transferQuantity',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'applicantFilter',
        label: 'label.sith.stool.sithMesStool26StockTransfer.filter.applicant',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'applyTimeRteFilter',
        label: 'label.sith.stool.sithMesStool26StockTransfer.filter.applyTimeRte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'applyTimeLteFilter',
        label: 'label.sith.stool.sithMesStool26StockTransfer.filter.applyTimeLte',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'isTransferFilter',
        label: 'label.sith.stool.sithMesStool26StockTransfer.filter.isTransfer',
        disabled: false,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'singlePriceFilter',
        label: 'label.sith.stool.sithMesStool26StockTransfer.filter.singlePrice',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'totalPriceFilter',
        label: 'label.sith.stool.sithMesStool26StockTransfer.filter.totalPrice',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'workOrderCodeFilter',
        label: 'label.sith.stool.sithMesStool26StockTransfer.filter.workOrderCode',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'statusFilter',
        label: 'label.sith.stool.sithMesStool26StockTransfer.filter.status',
        disabled: false,
        form: {
        type: 'entitySelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emActProcessStatus'
            ,showLabelSelectOne: true
                    ,selectFilter:{processBusinessEntityFilter:'SithMesStool26StockTransfer',statusFilter:1}
        }
        },
];


    const entityFormConfigs = [
        {
        key: 'material',
        label: 'label.sith.stool.sithMesStool26StockTransfer.entity.material',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'materialDesc',
        label: 'label.sith.stool.sithMesStool26StockTransfer.entity.materialDesc',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'oldProjectCode',
        label: 'label.sith.stool.sithMesStool26StockTransfer.entity.oldProjectCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'oldSo',
        label: 'label.sith.stool.sithMesStool26StockTransfer.entity.oldSo',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'oldWbs',
        label: 'label.sith.stool.sithMesStool26StockTransfer.entity.oldWbs',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'newProjectCode',
        label: 'label.sith.stool.sithMesStool26StockTransfer.entity.newProjectCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'so',
        label: 'label.sith.stool.sithMesStool26StockTransfer.entity.so',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'wbs',
        label: 'label.sith.stool.sithMesStool26StockTransfer.entity.wbs',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'transferQuantity',
        label: 'label.sith.stool.sithMesStool26StockTransfer.entity.transferQuantity',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'applicant',
        label: 'label.sith.stool.sithMesStool26StockTransfer.entity.applicant',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'applyTime',
        label: 'label.sith.stool.sithMesStool26StockTransfer.entity.applyTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'isTransfer',
        label: 'label.sith.stool.sithMesStool26StockTransfer.entity.isTransfer',
        sortable: true,
        disabled: false,
        form: {
        type: 'boolean',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'singlePrice',
        label: 'label.sith.stool.sithMesStool26StockTransfer.entity.singlePrice',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'totalPrice',
        label: 'label.sith.stool.sithMesStool26StockTransfer.entity.totalPrice',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.stool.sithMesStool26StockTransfer.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                }
        },
]

export {SithMesStool26StockTransfer, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
